import {
  LuAnchor,
  LuApple,
  LuBell,
  LuBike,
  LuBird,
  LuBookOpen,
  LuBug,
  LuCamera,
  LuCar,
  LuCastle,
  LuCat,
  LuCloud,
  LuClover,
  LuCoffee,
  LuCroissant,
  LuCrown,
  LuDiamond,
  LuDog,
  LuDroplet,
  LuFeather,
  LuFish,
  LuFlame,
  LuFlower,
  LuGamepad2,
  LuHeart,
  LuIceCreamCone,
  LuKey,
  LuLeaf,
  LuMoon,
  LuMountain,
  LuMusic,
  LuPizza,
  LuPlane,
  LuRabbit,
  LuRainbow,
  LuRocket,
  LuShield,
  LuShirt,
  LuSnail,
  LuSnowflake,
  LuSquirrel,
  LuStar,
  LuSun,
  LuTent,
  LuTreePalm,
  LuTreePine,
  LuTurtle,
  LuUmbrella,
  LuWaves,
  LuWind,
  LuZap,
} from "react-icons/lu";

/**
 * The pictures used on the memory cards. The shared game rules only know the NAME of an icon (so the server never
 * needs the picture); this table turns the name into the drawing.
 */
type Glyph = (p: { size?: number | string; className?: string; "aria-hidden"?: boolean | "true"; strokeWidth?: number }) => any;
export const GLYPHS: Record<string, Glyph> = {
  LuAnchor,
  LuApple,
  LuBell,
  LuBike,
  LuBird,
  LuBookOpen,
  LuBug,
  LuCamera,
  LuCar,
  LuCastle,
  LuCat,
  LuCloud,
  LuClover,
  LuCoffee,
  LuCroissant,
  LuCrown,
  LuDiamond,
  LuDog,
  LuDroplet,
  LuFeather,
  LuFish,
  LuFlame,
  LuFlower,
  LuGamepad2,
  LuHeart,
  LuIceCreamCone,
  LuKey,
  LuLeaf,
  LuMoon,
  LuMountain,
  LuMusic,
  LuPizza,
  LuPlane,
  LuRabbit,
  LuRainbow,
  LuRocket,
  LuShield,
  LuShirt,
  LuSnail,
  LuSnowflake,
  LuSquirrel,
  LuStar,
  LuSun,
  LuTent,
  LuTreePalm,
  LuTreePine,
  LuTurtle,
  LuUmbrella,
  LuWaves,
  LuWind,
  LuZap,
};
